import {
    FETCH_PRODUCTS_ERROR,
    FETCH_PRODUCTS_REQUEST,
    FETCH_PRODUCTS_SUCCESSFUL,
} from '../actions'
import first from 'lodash/first'

const initialState = {
    
}

const products = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_PRODUCTS_REQUEST:
            if (!action.payload.id) return state
            return {
                ...state,
                [action.payload.id]: {
                    shopItems: action.payload.shopItems,
                    loading: true,
                }
            }
        case FETCH_PRODUCTS_ERROR:
            if (!action.payload.id) return state
            return {
                ...state,
                [action.payload.id]: {
                    loading: false,
                    error: action.payload.message
                }
            }
        case FETCH_PRODUCTS_SUCCESSFUL:
            // TODO Need to do better with the shop the look dialog
            if (!action.payload.id || action.payload.id === 'dialog') return state
            return {
                ...state,
                [action.payload.id]: {
                    ...state[action.payload.id],
                    loading: false,
                    loaded: true,
                    shopItems: state[action.payload.id].shopItems.map(item => {
                        const product = first(action.payload.products.filter(product => product.sku === item.sku));
                        if (!product) return item;
                        return {
                            ...item,
                            ...product,
                            loaded: true
                        }
                    })
                }
            }
        default:
            return state
    }
}

export default products



// WEBPACK FOOTER //
// ./src/reducers/products.js